export default {
	props: {
		loadOnStart: {
			type: Boolean,
			default: true,
		},
	}
}
